<template>
  <aside class="DesktopView">
    <div class="popup" :hidden="status !== 'showing'">
      <SimplePopup
        v-if="content.kind === 'simple'"
        :content="content.simplePopup"
        v-bind="{ hidePopup, ctaClicked }"
      />
      <MultichoicePopup
        v-if="content.kind === 'multichoice'"
        :content="content.multichoicePopup"
        v-bind="{ hidePopup, ctaClicked }"
      />
    </div>
  </aside>
</template>

<script>
import { pushAnalyticsEvent } from '~/lib/analyticsEvents.js'

import MultichoicePopup from './MultichoicePopup/index.vue'
import SimplePopup from './SimplePopup.vue'

function pushPopupAnalyticsEvent(content, action) {
  switch (content.kind) {
  case 'simple':
    pushAnalyticsEvent({
      scope: 'simplePromoPopup',
      action,
      content: content.simplePopup,
    })
    break;
  case 'multichoice':
    pushAnalyticsEvent({
      scope: 'multichoicePromoPopup',
      action,
      content: content.multichoicePopup,
    })
    break;
  }
}

export default {
  components: {
    MultichoicePopup,
    SimplePopup,
  },
  props: {
    content: Object,
    triggered: Boolean,
    triggeredBy: String,
  },
  data() {
    return {
      status: 'ready',
    }
  },
  methods: {
    hidePopup(reason) {
      this.status = 'dismissed'
      if (reason === 'closed') {
        pushPopupAnalyticsEvent(this.content, 'dismissed')
      }
    },
    ctaClicked() {
      pushPopupAnalyticsEvent(this.content, 'ctaClicked')
    },
  },
  watch: {
    triggered(value) {
      if (value && this.status === 'ready') {
        this.status = 'showing'
        switch (this.triggeredBy) {
        case 'timeout':
          pushPopupAnalyticsEvent(this.content, 'revealedAfterTimeout')
          break;
        case 'scrolling':
          pushPopupAnalyticsEvent(this.content, 'revealedAfterScrolling')
          break;
        }
      }
    },
  },
}
</script>

<style scoped>

@keyframes revealPopup {
  from {
    bottom: -500px;
  }
  to {
    bottom: 0;
  }
}

.popup {
  position: fixed;
  left: 0;
  bottom: 0;
  width: 100%;
  animation: revealPopup 0.5s;
  z-index: 30;
}

@media (--screen-lg) {
  .popup {
    width: auto;
    left: auto;
    right: 2.5rem;
  }
}
</style>
